<template>
    <div class="privacyPage">
        <header class="mainHeader">
            <div class="mainHeader__inner">
                <img src="https://www.tcl.eu/bundles/tclapp/img/logo/tcl.svg" width="175" height="49" alt="TCL The Creative Life">
            </div>
        </header>

        <main class="mainCenter">
            <section class="stage">
                <div class="stage__bg" style="background-image: url('https://dmayeb5ar6kq1.cloudfront.net/common/5afe96406f1ca_591efa86bf9d0_COMPARATEUR.jpg')"></div>
                <div class="mainContent__center">
                    <div class="grid">
                        <div class="grid__col-6 grid__col-md-12 grid--order-0-md grid--align-center">
                            <div class="stage__text">
                                <h1 class="tl1">
                                    Privacy Notice – Smart TV Services
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="mainContent__section">
                <div class="mainContent__center">
                    <p>
                        We respect your privacy when handling your personal data. This Privacy Notice describes the entity responsible for the processing of personal data we collect from you in connection with the use of our Smart TV services ("Services"), what types of personal data we collect about you, what we do with it, and your rights in relation to our use of the personal data.
                    </p>
                    <h3>
                        1. Data controller and representative in the European Union
                    </h3>
                    <p>
                        The collection, processing and use of the personal data collected from you when using the Services is conducted by Shenzhen TCL New Technology Co., Ltd., No. 5, Industrial Avenue (M), Sheko Industrial Zone, Shenzhen City, Guangdong Province, China ("Company"). Our contact details as well as the contact details of our representative in the European Union are provided under Section 12 below. Please note, however, that we are not responsible for all data processing activities set out below. We have nevertheless included a description of the respective activities in our Privacy Notice because this processing is connected with your use of the Smart TV.
                    </p>

                    <h3>
                        2. Data processing consent
                    </h3>
                    <p>
                        Some of the data processing activities that we conduct require your consent, e.g. the use of your personal data for the purpose of improving the Services.
                    </p>
                    <p>
                        Consent is voluntary and you will still be able to use the Services if you do not consent. However, you may see content that is not tailored to your preferences. Irrespective of your consent we reserve the right to process your personal data to the extent permitted by applicable law.
                    </p>
                    <p>
                        You may withdraw your consent at any time. The withdrawal of consent shall not affect the lawfulness of processing based on consent before its withdrawal. In order to withdraw your consent and/or to object (c.f. Section 10 and Appendix Your Rights below for your rights to object), please change the privacy settings of your Smart TV accordingly.
                    </p>

                    <h3>
                        3. Specific categories of personal data
                    </h3>
                    <p>
                        We process in particular the following data categories:
                    </p>
                    <p>
                        Device-ID: Your Smart TV stores a fixed unique number that enables us to identify and authenticate the Smart TV when you use the Services. This number is called the Device-ID.
                    </p>
                    <p>
                        IP address and MAC address: Your Smart TV will be assigned an IP address when accessing the Internet. If your Smart TV is behind a router (e.g. in a local home network or local WLAN), we may process the IP address of such router. The MAC address is a unique number assigned to each network interface of your Smart TV.
                    </p>
                    <p>
                        Device specific information: The Smart TV stores several information about itself and its configuration. This information includes the Smart TV type, the version of the operation system of the Smart TV, its panel resolution, the project ID (i.e. information regarding configuration files), the user agent, browser name, browser version, and the language and country that have been configured in the Smart TV.
                    </p>
                    <p>
                        These information will be used by us and will be provided to our service partner and content partners for the purposes described below.
                    </p>

                    <h3>
                        4. Purposes for which we process and/or use your personal data and legal bases
                    </h3>
                    <p>
                        The purposes for which we process your personal data and the respective legal bases are described below. To the extent that contractual purposes are mentioned below as legal basis, we cannot provide you with the Services if you do not provide us with the respective data. To the extent that your consent is mentioned as legal basis, you are free to provide or withhold your consent. If you do not provide your consent, we will not process your personal data for the respective purpose.
                    </p>
                    <ul>
                        <li>
                            Providing the Services: We use the IP address and MAC address, Device-ID, the version of the operation system of the Smart TV, client type of your Smart TV and its panel resolution, the project ID (i.e. information regarding configuration files), your DTV channel list, viewed channels, time zone, country and language settings to provide your Smart TV with access to the Services and services provided by content partners. Purposes include (but are not limited to) providing location based services to you (e.g. weather forecasts); abuse handling, management of security incidents, monitoring of availability of the Services, and providing backup services of user preferences.
                        </li>
                        <p>
                            When you use the Services your Smart TV will request data from the Services via the Internet. As part of these requests your IP address as described above and the language and country that has been configured in your Smart TV will be transmitted to our service partner. Our service partner will process the respective data in accordance with its privacy notice.
                        </p>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) General Data Protection Regulation (“GDPR”).
                        </p>

                        <li>
                            Service Settings: As part of the regular functionality of the Services you can manually arrange the order in which apps are displayed by the Services. Our service partner will store your arrangement and other preferences you may set during use of the Services. This information will be linked to the Device-ID.
                        </li>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>

                        <li>
                            Authentication: Whenever you connect your Smart TV to the Internet and turn on the Smart TV, it will automatically connect to the Services, which are managed by our service partner. Your Smart TV will then be authenticated as being certified for access to the Services. For authentication purposes, the Services store one or more unique numeric identifiers related to your Smart TV. We use the Device-ID and MAC address for authentication purposes. We also provide the Device-ID to selected content partners for authentication purposes. These content partners use the Device-ID to authenticate your Smart TV for access to services provided by a content partner.
                        </li>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>

                        <li>
                            Remote diagnostics: As part of the Services, we provide you with remote diagnostic services. Therefore, we process the Device-ID, device number, serial number, MAC address, and error logs, error codes and error descriptions which are automatically provided by the faulty module (application, middleware system).
                        </li>
                        <p>
                            In addition, if you call our customer support, subject to your prior authorization, a support agent can also remotely access your TV and preform further remote diagnostic services. In such case, the customer support agent receives access to your TV and networks, application and stored data files, and may process the Device-ID, device number, serial number, MAC address, error logs, error codes, error descriptions, Terminal ID, installed APP information, screenshot of TV and connected USB/Bluetooth device information for evaluation of the state of the TV and associated applications and data. The error logs may contain information, such as TV program history, music play list, the username and password of the APP if a third party APP used for the broadcast has not encrypted such information. This will be done to diagnose problems, modify system settings pursuant to your request, or to correct reported issues. In addition, upon request, customer support members may troubleshoot, run programs or install/uninstall software, reconfigure and/or otherwise perform service or technical support work on the TV.
                        </p>
                        <p>
                            Any remote access will only take place after you have enabled the remote support function by ticking the designated check box on your TV and will terminate after the respective session.
                        </p>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>

                        <li>
                            After-sales service: Pursuant to applicable law you may have warranty or similar rights to obtain after-sales services. TCL Europe, 9-15 rue Rouget de L'Isle- 92130 Issy- Les-Moulineaux, France is responsible for handling warranty claims and other requests for after-sales services and the processing of your personal data associated therewith. I.e., for the purposes of after sales services, TCL Europe acts as data controller and we are not responsible for the respective processing of your personal data.
                        </li>
                        <p>
                            When you ask for our after-sales related service, your name, e-mail address, phone number, service request and postal address included in the invoice may be required for the purpose of providing you with the after-sales service. The information may also be collected through the after-sales partners of our resellers or authorized service providers if you call them for service. You can contact TCL Europe under the contact details stated in Section 12 below for more information about the protection of personal data in connection with after-sales services.
                        </p>
                        <p>
                            The legal basis for the respective processing is the obligation to comply with legal obligations pursuant to Article 6 (1) c) GDPR.
                        </p>

                        <li>
                            T-Channel: T-Channel is the main page for the use of the Smart TV on Linux operating system (please see below for the use of the android operating system) and allows you to select certain content.
                        </li>
                        <p>
                            The legal basis for the processing of your personal data that is necessary for your use of the T-Channel are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>
                        <p>
                            Subject to your prior consent, we will also monitor the use of the T-Channel, i.e.:
                            <ul>
                                <li>
                                    When you start to use T-Channel, we will record the time of entering and exiting T-Channel.
                                </li>
                                <li>
                                    When you start to play a video of T-Channel, we will record the name and the duration time of the video (not applicable to Netflix, YouTube or any other service provided by a third party).
                                </li>
                                <li>
                                    When you enter or exit a page, we will record the staying time on the page.
                                </li>
                                <li>
                                    When you move your cursor from one location to another, or enter an application, we will record this event.
                                </li>
                                <li>
                                    When you install, remove or update applications, we will record these events, including the name of applications.
                                </li>
                            </ul>
                        </p>
                        <p>
                            We collect these information mainly for big data analysis to improve products and to provide better content services to users.
                        </p>
                        <p>
                            The legal basis for the processing of your personal data in connection with the monitoring of your use of the T-Channel is your consent pursuant to Article 6 (1) a) GDPR.
                        </p>
                        <p>
                            If you have bought an Android TV and use Google’s android operating system, your personal data will be processed by Google and we are not responsible for such processing. Please refer to Google’s privacy notice for information about the related processing of your data and your respective rights.
                        </p>

                        <li>
                            T-Cast: T-Cast allows you to control your TV using your phone and to share videos, music and pictures stored in your smart phone on the TV. T-Cast also allows you to mirror your smartphone on your TV.
                        </li>

                        <p>
                            The download and use of the app is voluntary. If you download and use the app, we will process the MAC address to calculate how many T–Cast versions have been used in the market. This is required to be able to offer you this service. If you use our second screen functionality, the controls you activate on the application and the country and language settings, DTV channel list, favorite channels lists, schedule lists, Device-ID, current channel, protocol version and IP address of your Smart TV will be collected and processed by us on our servers. Our servers will then control your Smart TV as directed by you in the app.
                        </p>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>

                        <li>
                            TCL Assistant: The TCL Assistant is a functionality allowing your TV to connect to Amazon Alexa compatible devices (such as Echo) to control such device through your voice. In order to use this function, you need to first register your TV on the Amazon website using the TCL code that can be found on your TV. You can then issue verbal instructions to the Amazon Alexa compatible device by pressing the microphone button on the remote control of your TV.
                        </li>
                        <p>
                            If you use the TCL Assistant, your TV collects your voice and sends it to the Amazon Alexa Cloudfor voice recognition and further processing. Your data will be directly transferred to Amazon and no data will be further processed or stored locally on your TV. Please refer to Amazon’s privacy notice for information on further processing of your data by Amazon.
                        </p>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>

                        <li>
                            Alexa Voice Recognition (AVS): AVS is a functionality allowing you to control the TV through your voice. In order to use this function, you need to first register your TV on the Amazon website using the registration code generated by Amazon. You can then issue verbal instructions to the TV by pressing the microphone button on the remote control of your TV.
                        </li>
                        <p>
                            If you use the AVS, your TV collects your voice and sends it to the Amazon Alexa Cloud for voice recognition and further processing. Your data will be directly transferred to Amazon and no data will be stored locally on your TV. Please refer to Amazon’s privacy notice for information on further processing of your data by Amazon.
                        </p>
                        <p>
                            When you use the AVS, your TV name will be required to allow us to find which TV you would like to control.
                        </p>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>
                        <p>
                            Further, we will record how often and how long you have used the AVS, and what function you have used within AVS. We collect this information to improve products and to provide better content services to users.
                        </p>
                        <p>
                            The legal basis for the respective processing of your personal data are our legitimate interests pursuant to Article 6 (1) f) GDPR. More information on the balancing test is available upon request.
                        </p>

                        <li>
                            Software updates: Software updates are part of the Services. Thus, each time your Smart TV is powered on, it will provide us with the IP address, Device-ID, device number, software version, client type of your Smart TV, project ID (i.e. configuration files), user ID, and serial number to look whether software updates are available and to offer you and provide you with appropriate software updates.
                        </li>
                        <p>
                            The legal basis for the respective processing of your personal data are contractual purposes pursuant to Article 6 (1) b) GDPR.
                        </p>

                        <li>
                            Law enforcement: We may be required to provide data to competent law enforcement authorities or courts of justice. If we do so, we will only do so subject to a binding legal instrument like a warrant or a judicial order, which requires us to cooperate with the relevant authorities.
                        </li>
                        <p>
                            The legal basis for the respective processing is our obligation to comply with legal obligations pursuant to Article 6 (1) c) GDPR.
                        </p>
                    </ul>

                    <p>
                        Use of the Services is possible by using pseudonyms, unless specific services require that you provide your name and/or email address.
                    </p>

                    <h3>
                        5. Privacy and safety of children under 16
                    </h3>
                    <p>
                        We understand the importance of taking extra precautions to protect the privacy and safety of children using our Services. Children under the age of 16, or equivalent minimum age in the relevant jurisdiction, are not permitted to provide their personal information via the TV set or when they call for after-sales service, unless their parent provided verifiable consent.
                    </p>
                    <p>
                        As we never collect birth dates of users, we can't identify the age of users. But if we learn that we have collected the personal information of a child under 16, or equivalent minimum age depending on the jurisdiction, outside of the above circumstances we will take steps to delete the information as soon as possible.
                    </p>

                    <h3>
                        6. Third party apps
                    </h3>
                    <p>
                        Your Smart TV allows the use of apps provided by third parties, such as Netflix, YouTube or HbbTV (red button service provided by TV broadcasters). You may download the apps from the app store or activate third party apps that are already pre-installed on your device. Third party apps that are pre-installed on your device do not collect personal data without your prior authorization. E.g. Netflix is already pre-installed on the device but only collects data when you log into your Netflix account. HbbTV only collects data when you consent to the collection by pressing the designated button on your remote control.
                    </p>
                    <p>
                        If you enable a third party app, personal data about you may be processed by the app provider. We are not responsible for such processing; please refer to the privacy notice of the third party app for information about the related processing of your data and your respective rights.
                    </p>

                    <h3>
                        7. Categories of recipients
                    </h3>
                    <p>
                        We share your personal data collected during your use of the Services only with third party content partners if you request certain content provided by such content partners or with service providers as data processors assisting us with the provision of the Services.
                    </p>
                    <p>
                        We share your personal data with other third parties only if we are obligated to do so on the basis of legal requirements (e.g. to courts or criminal prosecution authorities), if you have consented to the respective sharing or if the sharing is otherwise lawful under applicable law.
                    </p>

                    <h3>
                        8. Countries in which your data will be processed
                    </h3>
                    <p>
                        We and/or some of the recipients of your personal data listed above may be located outside of the European Economic Area (e.g. in the Peoples Republic of China, or United States of America). Therefore, your personal data may be processed in countries where the data protection laws may provide a different level of protection compared to the laws in your jurisdiction and which are not recognized as providing an adequate level of protection of personal data in accordance with the GDPR. The countries which provide an adequate level of data protection from a European data protection law perspective include Andorra, Argentina, Canada, Switzerland, Faeroe Islands, Guernsey, the State of Israel, Isle of Man, Jersey, New Zealand and the Eastern Republic of Uruguay. Recipients in the USA may partially be certified under the EU-U.S. Privacy Shield and thereby recognized as providing an adequate level of data protection from an European data protection law perspective.
                    </p>
                    <p>
                        Where required, we will implement appropriate safeguards with regard to data transfers to recipients outside of the European Union that do not provide an adequate level of data protection. A copy of the respective measure may be requested by contacting us as stated under Section 12. below.
                    </p>

                    <h3>
                        9. Storage Period
                    </h3>
                    <p>
                        Your personal data will be retained as long as necessary to provide you with the Services. For most data this generally means that we will retain your data for one month. For the purpose of remote diagnostics and after-sales services we may retain your data up to ten years. When we no longer need to use your personal data to comply with contractual or statutory obligations, we will remove it from our systems and records and/or take steps to properly anonymize it so that you can no longer be identified from it.
                    </p>

                    <h3>
                        10. Your rights
                    </h3>
                    <p>
                        Pursuant to applicable data protection law you may have the right to: request access to your personal data, request rectification of your personal data; request erasure of your personal data, request restriction of processing of your personal data; request data portability, and object to the processing of your personal data. Please note that these aforementioned rights might be limited under the applicable national data protection law. For further information on these rights please refer to the Appendix Your Rights below.
                    </p>
                    <p>
                        You also have the right to lodge a complaint with the competent data protection supervisory authority.
                    </p>
                    <p>
                        To exercise your rights please contact us as stated in Section 12 below.
                    </p>

                    <h3>
                        11. Changes to the Privacy Notice
                    </h3>
                    <p>
                        To improve our Services we may require amendments to this Privacy Notice – e.g. by the implementation of new technologies or the introduction of new services. We reserve the right to change or supplement this Privacy Notice at any time.
                    </p>

                    <h3>
                        12. Contact information and representative in the European Union
                    </h3>
                    <p>
                        If you have any questions about the Privacy Notice or would like to complain about our handling of your personal data, please contact us by using the following contact details:
                    </p>
                    <p>
                        Contact form: www.tcl.eu/en/contact-us
                    </p>
                    <p>
                        Our representative in the European Union is: TCL Europe having offices at 9-15 rue Rouget de L'Isle- 92130 Issy- Les-Moulineaux, France. You may contact TCL Europe via the contact form stated above.
                    </p>
                    <p>
                        Version: 2.0
                    </p>

                    <div class="stage__text">
                        <h1 class="tl1">
                            Appendix Your Rights
                        </h1>
                    </div>
                    <ul>
                    <li>
                        a. Right of access: You may have the right to obtain from us confirmation as to whether or not personal data concerning you is processed, and, where that is the case, to request access to the personal data. The access information includes - inter alia - the purposes of the processing, the categories of personal data concerned, and the recipients or categories of recipients to whom the personal data have been or will be disclosed. However, this is not an absolute right and the interests of other individuals may restrict your right of access.
                    </li>
                    <p>
                        You may have the right to obtain a copy of the personal data undergoing processing. For further copies requested by you, we may charge a reasonable fee based on administrative costs.
                    </p>
                    <li>
                        b. Right to rectification: You may have the right to obtain from us the rectification of inaccurate personal data concerning you. Depending on the purposes of the processing, you may have the right to have incomplete personal data completed, including by means of providing a supplementary statement.
                    </li>
                    <li>
                        c. Right to erasure ("right to be forgotten"): Under certain circumstances, you may have the right to obtain from us the erasure of personal data concerning you and we may be obligated to erase such personal data.
                    </li>
                    <li>
                        d. Right to restriction of processing: Under certain circumstances, you may have the right to require the restriction of processing of personal data concerning you. In this case, the respective data will be marked and may only be processed by us for certain purposes.
                    </li>
                    <li>
                        e. Right to data portability: Under certain circumstances, you may have the right to receive the personal data concerning you, which you have provided to us, in a structured, commonly used and machine-readable format and you may have the right to transmit those data to another entity without hindrance from us.
                    </li>
                    <li>
                        f. Right to object: Under certain circumstances, you may have the right to object, on grounds relating to your particular situation, or where personal data are processed for direct marketing purposes at any time to the processing of your personal data by us and we can be required to no longer process your personal data.
                    </li>
                    <p>
                        Moreover, if your personal data is processed for direct marketing purposes, you have the right to object at any time to the processing of personal data concerning you for such marketing, which includes profiling to the extent that it is related to such direct marketing. In this case your personal data will no longer be processed for such purposes by us.
                    </p>
                    </ul>

                    <div class="stage__text">
                        <h1 class="tl1">
                            Cookie Notice – Smart TV Services
                        </h1>
                    </div>
                    <p>
                        We respect your privacy when using Smart TVs manufactured and Services provided by us. Cookies are used by many websites and other internet services and your Smart TV will accept, store and transmit cookies to ensure that these websites and services operate properly.
                    </p>
                    <p>
                        We do not use cookies when providing the Services to you. However, third parties (e.g. third party app providers) may use cookies when you use the Smart TV to access their services. This Cookie Notice can only provide limited information concerning cookies that may be placed by third parties. For information on the actual cookies used by third parties and their functionalities we refer you to the respective cookie notices of such third parties. However, in this Cookie Notice we provide a general description which cookies can be set on your Smart TV and how you can manage them.
                    </p>
                    <h3>
                        1. What is a cookie?
                    </h3>
                    <p>
                        Cookies are small text files that may be placed on your Smart TV. When a website or the red-button service of a TV station is accessed, the website or service may store a cookie in the Smart TV. During subsequent accesses, a cookie that is placed on your Smart TV will send information to the party that has placed the cookie. Cookies are extremely common and used on a number of websites and services. Each cookie will typically contain the name of the domain from which the cookie has come, the "lifetime" of the cookie, and a value (usually a unique number). For a more thorough explanation of what cookies are and how they operate, please visit www.allaboutcookies.org.
                    </p>
                    <p>
                        Cookies can be categorized into functional cookies and non-functional cookies. Functional cookies are cookies that are strictly required for the purpose of providing you services. Non-functional cookies are all other cookies.
                    </p>
                    <h3>
                        2. Third party websites
                    </h3>
                    <p>
                        When you visit websites or services of third parties via the Services of your Smart TV, it is possible that such websites or services place cookies on your Smart TV, and that such websites track and store your interactions on such websites. We do not request or encourage such activities and will not use such information. Please refer to the respective cookie and privacy notices of such websites and services for more information about such parties’ use of such cookies.
                    </p>
                    <h3>
                        3. Cookie deletion
                    </h3>
                    <p>
                        Your user interface of your Smart TV allows you to delete all cookies and other local browser storage from the Smart TV. It is highly advisable to remove all cookies and locally stored settings prior to selling or giving away your Smart TV.
                    </p>
                    <p>
                        Version: 2.0
                    </p>
                </div>
            </section>
        </main>

        <footer class="mainFooter">
            <p> © 2018 TCL Inc. </p>
        </footer>
    </div>
</template>

<script>
export default {
    name: "PrivacyPolicy"
}
</script>

<style scoped>
.privacyPage h3 {
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 25px;
    font-family: 'opensans_regular', sans-serif;
    font-size: 1.2em;
    font-size: 1.2rem;
    font-weight: normal;
    color: #262626;
    line-height: 1.25em;
}

p,
ul li {
    font-size: 0.92em;
    font-size: 0.92rem;
}

.privacyPage section {
    font: 1.2em/1.6em 'opensans_regular', sans-serif;
    color: #666;
    background-color: #FFF;
    line-height: 1.25em;
}

.privacyPage .mainHeader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 54px;
    z-index: 999;
    background-color: #0d0d0d;
    transition: top 0.3s;
}

.privacyPage .mainHeader__inner {
    display: table;
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    padding: 0 30px;
}

.privacyPage .mainCenter {
    max-width: 1276px;
    padding: 30px;
    padding-top: 60px;
    margin: 0 auto;
}


.privacyPage .mainContent__center {
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    overflow: hidden;
}

.privacyPage .mainHeader__logo {
    position: relative;
    width: 105px;
    height: 55px;
    overflow: hidden;
}

.privacyPage .mainContent__center {
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    overflow: hidden;
}

.privacyPage .stage {
    position: relative;
    padding: 30px 0;
    min-height: 330px;
}

.stage__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.view {
    padding-top: 54px;
}

footer {
    margin: 2rem auto;
    text-align: center;
}


/* .mainHeader__logo, .mainHeader__nav {
    display: table-cell;
    height: 100%;
    vertical-align: middle;
} */
</style>




// WEBPACK FOOTER //
// src/pages/PrivacyPolicy.vue